import { createStyles, makeStyles, Theme, Typography, useMediaQuery } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titleWrapper: {
            textAlign: 'center',
            marginBottom: theme.spacing(3)
        },
        title: {
            color: theme.palette.action.active,
            marginBottom: theme.spacing(1),
            '& $emphasized': {
                color: theme.palette.primary.main,
            }
        },
        emphasized: {
            fontWeight: 'bold'
        },
    })
);

export const OrganizationSignUpHeader = observer(() => {

    /********* React hooks *********/

    const classes = useStyles();
    const xsDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

    /********* Render *********/

    return (
        <div className={classes.titleWrapper}>
            <Typography variant={xsDown ? 'h4' : 'h3'} className={classes.title}>
                Recruit volunteers to <span className={classes.emphasized}>power</span> your mission.
            </Typography>
        </div>
    );
});
